import { ProgressIndicator } from "@fluentui/react";
import React from "react";

export const LineaProgreso = ({ ocultar = true, prefix = "" }) => {
  return (
    <div hidden={ocultar}>
      <ProgressIndicator
        description={`${prefix} Espere Un Momento`}
        barHeight={3}
      />
    </div>
  );
};
